// extracted by mini-css-extract-plugin
export default {"regionList":"PV6We76tbhp-iNAWY6sGf"};